import {NO_MAX_DATE_VALUE} from 'common/components/calendar/types';
import {DateRangeType} from 'common/types/reports/bookmark';

import {DateRange} from './date-range';

export class ExperimentDateRange extends DateRange {
  public getDateRangeTypeOptions() {
    return [DateRangeType.Between, DateRangeType.Since];
  }

  public override getCalendarMaxDate(): string | null {
    return NO_MAX_DATE_VALUE;
  }
}
